"use client"

import Image from "next/image"
import { ReactNode } from "react"

import { useFrontendPreferences } from "@lib/frontend-preferences"
import LocalizedClientLink from "@modules/common/components/localized-client-link"

export type Crumb = { label: string; href: string }

type CatalogHeroProps = {
  title: string
  titleTestId?: string
  description?: string | null
  image?: string | null
  count?: number
  crumbs?: Crumb[]
  children?: ReactNode
}

export default function CatalogHero({
  title,
  titleTestId,
  description,
  image,
  count,
  crumbs = [],
  children,
}: CatalogHeroProps) {
  const { t } = useFrontendPreferences()

  return (
    <header className={image ? "sahil-hero sahil-hero--media" : "sahil-hero"}>
      <div className="sahil-hero__body">
        <nav className="sahil-hero__crumbs" aria-label="Breadcrumb">
          <LocalizedClientLink href="/store">{t.categoryIndex.home}</LocalizedClientLink>
          {crumbs.map((crumb) => (
            <span key={crumb.href} className="contents">
              <i aria-hidden="true" className="rtl:rotate-180">›</i>
              <LocalizedClientLink href={crumb.href} data-testid="sort-by-link">
                {crumb.label}
              </LocalizedClientLink>
            </span>
          ))}
        </nav>
        <h1 data-testid={titleTestId}>{title}</h1>
        {description && <p>{description}</p>}
        {typeof count === "number" && (
          <span className="sahil-acc-chip">
            {t.categoryIndex.products.replace("{count}", String(count))}
          </span>
        )}
        {children}
      </div>
      {image && (
        <div className="sahil-hero__media">
          <Image
            src={image}
            alt={title}
            fill
            sizes="(min-width: 1024px) 40vw, 100vw"
            className="object-cover"
          />
        </div>
      )}
    </header>
  )
}
